// extracted by mini-css-extract-plugin
module.exports = {"app":"App_app_3cl75","page-container":"App_page-container_w9FCH","loading":"App_loading_2wMPE","show-share-mask":"App_show-share-mask_1B596","share-text":"App_share-text_2GRrX"};